// Flux d'authentification : initData Telegram → /auth/verify → utilisateur vérifié.
// La SOURCE DE VÉRITÉ est le serveur (signature HMAC) ; on ne fait pas confiance
// aux données client seules.
import { tg, hasInitData, type TgUser } from "./telegram";
import { verifyInitData, type StreakInfo } from "./api";

export type AuthResult =
  | { ok: true; user: TgUser | null; authDate: number; streak: StreakInfo | null }
  | { ok: false; reason: "no-telegram" | "no-initdata" | "api"; error?: string };

/**
 * Authentifie l'utilisateur courant.
 * - Hors Telegram → reason "no-telegram".
 * - Dans Telegram mais sans initData → reason "no-initdata".
 * - initData présent mais rejeté par l'API → reason "api" (+ code d'erreur).
 */
export async function authenticate(): Promise<AuthResult> {
  // Bypass de développement : `npm run dev` puis ouvrir http://localhost:5173/?dev
  // pour tester les écrans/jeu sans Telegram. Inactif en build de production.
  if (import.meta.env.DEV && new URLSearchParams(location.search).has("dev")) {
    return { ok: true, user: { id: 0, first_name: "Dev", username: "dev" }, authDate: 0, streak: null };
  }
  if (!tg) return { ok: false, reason: "no-telegram" };
  if (!hasInitData()) return { ok: false, reason: "no-initdata" };

  const res = await verifyInitData(tg.initData);
  if (res.ok) {
    return { ok: true, user: res.data.user, authDate: res.data.authDate, streak: res.data.streak ?? null };
  }
  return { ok: false, reason: "api", error: res.error };
}
